<template>
  <div id="item_shop">
    <van-nav-bar
      :title="document_title"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-row class="item_shop">
      <van-col span="22" offset="1" class="item_shop_vip">
        <van-col span="5" offset="1" class="item_shop_vip_avatar">
          <van-image
            width="8vh"
            height="8vh"
            round
            :src="user.head_image"
          />
        </van-col>
        <van-col span="12" class="item_shop_vip_center">
          <van-col span="24" class="item_shop_vip_center_title">{{ user.nick_name }}</van-col>
          <van-col span="24" class="item_shop_vip_center_time">{{ user_vip }}</van-col>
        </van-col>
        <van-col span="5" class="item_shop_vip_right">
          <img src="../assets/img/vip_img.png"/>
        </van-col>
      </van-col>
      <van-col span="24" class="item_shop_vip_bg">
        <van-col span="22" offset="1" class="item_shop_vip_bg_title">{{ $t('column.Membership_privileges')}}</van-col>
        <van-col  span="22" offset="1" class="item_shop_vip_type">
            <van-col span="6">
              <van-col span="24" class="item_shop_vip_type_img">
                <img src="../assets/img/vip_id.png"/>
              </van-col>
              <van-col span="24" class="item_shop_vip_type_title">{{ $t('column.Membership_logo')}}</van-col>
            </van-col>
            <van-col span="6">
              <van-col span="24" class="item_shop_vip_type_img">
                <img src="../assets/img/vip_gift1.png"/>
              </van-col>
              <van-col span="24" class="item_shop_vip_type_title">{{ $t('column.Exclusive_gift')}}</van-col>
            </van-col>
            <van-col span="6">
              <van-col span="24" class="item_shop_vip_type_img">
                <img src="../assets/img/gift_barrage.png"/>
              </van-col>
              <van-col span="24" class="item_shop_vip_type_title">{{ $t('column.Free_barrage')}}</van-col>
            </van-col>
            <van-col span="6">
              <van-col span="24" class="item_shop_vip_type_img">
                <img src="../assets/img/upgrade_vip.png"/>
              </van-col>
              <van-col span="24" class="item_shop_vip_type_title">{{ $t('column.Speed_up_upgrade')}}</van-col>
            </van-col>
        </van-col>
        <van-col  span="24" class="item_shop_vip_pay">
            <div class="item_shop_vip_price">
              <div v-for="(l) in vip_rule" :key="l.id" :class="['item_shop_vip_price_item' ,isActive === l.id ? 'item_shop_vip_price_bg' : '']" @click="vip_price_item(l.id)">
                <van-col span="24" class="item_shop_vip_price_item_day">{{ l.day_num }}{{ $t('other.days')}}</van-col>
                <van-col span="24" class="item_shop_vip_price_item_sum">{{ l.money }}<img :src="consumer_price_Icon"/> </van-col>
              </div>
            </div>
        </van-col>
        <van-col span="22" offset="1" class="item_shop_vip_btn" @click="vip_btn">{{ $t('btn.activate_now')}} </van-col>
      </van-col>

    </van-row>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog } from 'vant'
export default {
  data() {
    return {
      vip_rule: [],
      isActive: '',
      consumer_price_Icon: '',
      user_vip: '',
      document_title: '',
      user:[]
    }
  },
  created: function() {
    this.convert();
    this.document_title = this.$t('title.vip')
  },
  components: {
    [Dialog.name]: Dialog
  },
  methods: {
    convert: function() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=vip_list", {
        params : {
          user_id: uid,
          token: token
        }
      }).then(res =>{
        console.log(res.data)
        if (res.data.status === 0) {
          Toast(res.data.error)
          return false
        }
        this.vip_rule = res.data.data.vip_rule
        this.consumer_price_Icon = res.data.data.consumer_price_Icon
        this.user = res.data.data.user
        this.user_vip = this.user && this.user.vip_time ? this.$t('column.due_date') + ': ' + this.user.vip_time : this.$t('column.Members_not_opened')
      })
    },
    vip_price_item (val) {
      this.isActive = val
    },
    vip_btn () {
      if (this.isActive === '') {
        Toast(this.$t('Tips.select_opening_type'))
        return false
      }
      if (!this.user) {
        Toast(this.$t('Tips.User_login_expired'))
        return false
      }
      const vip_time = this.user.vip_time ? this.$t('Tips.Whether_to_renew') : this.$t('Tips.Purchase_VIP_members')
      Dialog.confirm({
        title: this.$t('Tips.Buying_members'),
        message: vip_time,
        confirmButtonColor: '#AE2CF1',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=prop_mall&act=pay_vip", {
          params : {
            user_id: uid,
            token: token,
            id: this.isActive
          }
        }).then(res =>{
          console.log(res.data)
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.convert()
          }
        })
      }).catch(() => {
        // on cancel
      })
    },
    onClickLeft() {
      this.$router.go(-1); // 返回上一页
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/item_shop_vip.vue